<template>
  <div class="sale-wrapper bj">
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button
          @click="onHandleBatchAdd"
          type="warning"
          icon="el-icon-upload2"
          >批量绑定送货员</el-button
        >
      </template>
    </Filtersearch>

    <div class="auto-table-flex">
      <el-table
        v-loading="loading"
        :data="tableData"
        height="100%"
        :border="true"
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="logistic_business_name"
          align="center"
          label="集配中心"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier_title"
          align="center"
          label="供应商"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier_mobile"
          align="center"
          label="供应商电话"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="state_txt"
          align="center"
          label="供应商状态"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier_deliver_name"
          align="center"
          label="送货员姓名"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="supplier_deliver_mobile"
          align="center"
          label="送货员电话"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="create_time"
          align="center"
          label="添加时间"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="is_independent_delivery_txt"
          align="center"
          label="是否三方送货员"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="is_auto_bind_txt"
          align="center"
          label="是否自动分配送货单"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.deliver_state == 2"
              @click="onHandle(scope.row)"
              >删除</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.deliver_state == 1"
              @click="onHandleDisabled(scope.row)"
              >禁用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        type="primary"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <batch-add-dialog
      ref="batchAdd"
      @submit-form="submitForm"
    ></batch-add-dialog>
  </div>
</template>
<script>
import Filtersearch from "@/components/Filtersearch.vue";
import batchAddDialog from "./modules/batchAddDialog/index.vue";
// import changeRecord from "./modules/changeRecord.vue";

export default {
  name: "supplier",
  components: {
    Filtersearch,

    batchAddDialog,
  },
  data() {
    return {
      currentPage: 0,
      total: 0,
      loading: false,
      disabledExport: false, // 导出按钮
      tableData: [],
      from: {
        page: 1,
        pageSize: 50,
        logistic_business_id: "", //	number	集配id
        supplier_id: "", //	number	供应商id
        supplier_mobile: "", //	string	供应商手机号
        supplier_deliver_name: "", //	string	货员名称
        supplier_deliver_mobile: "", //	string	送货员手机号
        is_independent_delivery: "", //	string	送货员手机号
      },
      from1: "",
      Selectionlist: [],
      Filtersearchlist: [
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          filterable: true,
          model: "logistic_business_id",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "business",
        },
        {
          type: "select",
          name: "供应商",
          clearable: true,
          filterable: true,
          model: "supplier_id",
          placeholder: "请选择供应商",
          label: "title",
          value: "id",
          selectoption: [],
          selectoptionname: "supplier",
        },

        {
          type: "input",
          name: "供货商电话",
          clearable: true,
          model: "supplier_mobile",
          placeholder: "请输入供货商电话",
        },
        {
          type: "input",
          name: "送货员",
          clearable: true,
          model: "supplier_deliver_name",
          placeholder: "请输入送货员姓名",
        },
        {
          type: "input",
          name: "送货员电话",
          clearable: true,
          model: "supplier_deliver_mobile",
          placeholder: "请输入送货员电话",
        }
      ],
    };
  },
  created() {
    this.from1 = JSON.parse(JSON.stringify(this.from));
    this.hqlist();
    this.getsearch();
  },
  watch: {},
  methods: {
    onHandleBatchAdd() {
      this.$refs.batchAdd.addBatchData();
    },
    /**
     * 刷新列表
     */
    submitForm() {
      this.from.page = 1;
      this.from1.page = 1;
      this.currentPage = 1;
      console.log("走这里了吗");
      this.hqlist();
    },
    onHandleDisabled(row) {
      this.$confirm("确定要禁用吗？", "提示", {
        center: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        customClass: "jn-confirm-message-style",
        iconClass: "el-icon-warning",
      }).then(() => {
        this.$api.payment
          .deliverdisabled({ deliver_map_id: row.id })
          .then((res) => {
            this.$message.success("禁用成功");
            this.hqlist();
          });
      });
    },
    onHandle(row) {
      this.$confirm("确定要删除吗？", "提示", {
        center: true,
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        customClass: "jn-confirm-message-style",
        iconClass: "el-icon-warning",
      }).then(() => {
        this.$api.payment
          .deliverdelete({ deliver_map_id: row.id })
          .then((res) => {
            this.$message.success("删除成功");
            this.hqlist();
          });
      });
    },
    changeRecordclcik(e) {
      this.$refs.changeRecordref.onInitData(e);
      // stafflog
    },

    getsearch() {
      this.$api.payment.searchData().then((res) => {
        this.Filtersearchlist.forEach((el) => {
          if (el.type == "select" && el.selectoptionname) {
            let obj = { [el.value]: "", [el.label]: "全部" };
            el.selectoption = [obj, ...res.data[el.selectoptionname]];
          }
        });
      });
    },
    Refresh() {
      Object.assign(this.$data.from, this.$options.data().from);
      this.from1 = JSON.parse(JSON.stringify(this.from));
      this.hqlist();
    },

    search(e) {
      this.from.page = 1;
      this.currentPage = 1;
      this.from = e;
      this.hqlist();
    },
    hqlist() {
      this.loading = true;
      this.$api.payment.delivermaplist(this.from).then((res) => {
        console.log(res, "获取数据");
        this.tableData = res.data.data;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      this.from.pageSize = val;
      this.from1.pageSize = val;
      this.hqlist();
    },
    handleCurrentChange(val) {
      this.from.page = val;
      this.from1.page = val;
      this.currentPage = val;
      this.hqlist();
    },
  },
};
</script>
<style lang="scss">
.sale-wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  //   background: #ffffff;
  padding: 10px;

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    // background-color: #000;
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
